module.exports = __webpack_public_path__ + "images/sepa-1_pI2o5.svg";